import { useCallbackEvent } from '@dni-react-hooks/use-callback-event'
import { type ReceiptType } from '@hooks-api/types/dataModel/eCommercePayments'
import { type CarrierValidationStatusType } from '../core/carrier-validation-status'
import * as invoiceService from '../core/invoice-service'
import { useFpCampaignCartStore } from './useFpCampaignCartStore'

export const useFpCampaignInvoiceService = (campaignId: number | null) => {
  const [, setCartValues] = useFpCampaignCartStore(campaignId)

  const setReceiptType = useCallbackEvent((receiptType: ReceiptType) => {
    setCartValues(state => ({
      ...state,
      invoice: invoiceService.setReceiptType(state.invoice, receiptType),
    }))
  })

  const setPhoneCarrierNumber = useCallbackEvent((phoneCarrierNumber: string) => {
    setCartValues(state => ({
      ...state,
      invoice: invoiceService.setPhoneCarrierNumber(state.invoice, phoneCarrierNumber),
    }))
  })

  const setCharityOrganization = useCallbackEvent((charityOrganization: string) => {
    setCartValues(state => ({
      ...state,
      invoice: invoiceService.setCharityOrganization(state.invoice, charityOrganization),
    }))
  })

  const setBusinessUbnTitle = useCallbackEvent((businessUbnTitle: string) => {
    setCartValues(state => ({
      ...state,
      invoice: invoiceService.setBusinessUbnTitle(state.invoice, businessUbnTitle),
    }))
  })

  const setBusinessUbn = useCallbackEvent((businessUbn: string) => {
    setCartValues(state => ({
      ...state,
      invoice: invoiceService.setBusinessUbn(state.invoice, businessUbn),
    }))
  })

  const setRefundStatement = useCallbackEvent((refundStatement: boolean) => {
    setCartValues(state => ({
      ...state,
      invoice: invoiceService.setRefundStatement(state.invoice, refundStatement),
    }))
  })

  const setCarrierValidationStatus = useCallbackEvent((carrierValidationStatus: CarrierValidationStatusType) => {
    setCartValues(state => ({
      ...state,
      invoice: invoiceService.setCarrierValidationStatus(state.invoice, carrierValidationStatus),
    }))
  })

  return {
    setReceiptType,
    setPhoneCarrierNumber,
    setCharityOrganization,
    setBusinessUbnTitle,
    setBusinessUbn,
    setRefundStatement,
    setCarrierValidationStatus,
  }
}
